import React, { Fragment } from 'react';
import { Button, ButtonGroup, Card, CardBody, CardFooter, CardHeader, Col, Container, FormFeedback, FormGroup, FormText, Input, Label, Row, Table, Nav, NavLink } from 'reactstrap';
import { ButtonGoBack, CompleteEmail, CompleteInput, CompleteSelect, InstructionAgreementBranch, PlaceHolderOption, SelectExamOrProfile } from '../../constant';
import { useAddAgreement } from '../../hooks/agreements/useAddAgreement';
import { SearchAsync } from '../../components/elements/SearchAsync';
import DeniReactTreeView from 'deni-react-treeview';
import Select from 'react-select';
import { TableAgreement } from '../../components/agreement/TableAgreement';
import 'animate.css';
import { InformationAgreement } from './InformationAgreement';
import { ModalCodeCsv } from './ModalCodeCsv';
import { ModalDeleteTest } from './ModalDeleteTest';
import zIndex from '@mui/material/styles/zIndex';
import { cedimi } from '../../constant/globalConstantsTypeClients'
import './StyleAgreement.css';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';



export const IndexAddAgreement = () => {

    const {
        //#region AGREEMENTS LIST
        listCompanies, listPayForms, listFinancingMethods, listUseCfdi, listSellers, listCommercialLines,
        ListBranchesTree, listDoctors,
        //#endregion

        //#region AGREEMENTS MODELS
        informationCompany, informationDoctor, examProfileState, loading, globalPercentage, loadingAgreement, typeFilterAgreement,
        pageSizeSelectDoctor,

        //FORM
        id_agreement, id_company, id_doctor, id_pay_method, id_financing_methods, id_commercial_line, id_seller, id_use_cfdi,
        contract_number, validity, sales_name, sales_phone, sales_email, payment_name, payment_phone,
        payment_email, observations, swift_code, is_global, payment_periodicity, credit_limit, percentage_credit_limit,
        checkSpecimenQuantity, quantity_sample, list_agrement_test, is_pay_for_compamy, required_invoice_company,

        //FORM METHODS
        handleInputChangeA, handleSelectValuesA,
        //REFS
        treeViewRef,
        //#endregion

        //#region VALIDATIONS AGREEMENTS
        validationsAgreement, visibilityInputs,
        //#endregion  

        //#region AGREEMENTS METHODS
        handleChangeCompany, handleChangeDoctor, handleSelectTest, handleChangeRange, handleChangePercentage,
        handleDeleteRange, handleAddRange, handleDeleteTest, handleChangePrice, handleGoBack,
        saveOrUpdateAgreement, handleCalculateGlobalPercentage, handleChangeTypeFilter, handleScrollPaginingDoctor,

        //#endregion
        number_format,

        //#region csv Exam and Profile
        setDatacsv, handleCsvLoading,
        //#region sanitaria
        check_sanitary, on_check_sanitary, handleCant, sample_periodicity, is_micro,

        //RETURN PAGINATION
        goNextPage, goPreviousPage, totalPages, actualPage, goToPage,
        prevPage, nextPage, totalRecords, resultCount, handleSearch,
        validCode,
        modalListEgress, toggleModalListEgress, listCode, handlemove,
        listRepit, priceTarifarion, profileT,

        //* MODAL DELETE TEST
        modalCancellation, method, toggleModalCancellation, handleTest, modalTitle, informationExams, handleDeleteTestCreate,
        //*CSV
        file, handleOnChange, ExamIndication, view_exams,
        charge_emergency, border_tax, address_sample_taking, _active_micro, results, loadingAgreementTest, isSearching, setGlobalPercentage,
        is_list_limited, on_check_list_limited,
        //* MOD AGREEMENTS
        agreement_mode, handleSave, showButton, agreement_discount_global, handleOnChangeSelect, _url, id_rate,
        handleCleanAgreements, listAgreement, getAgreementLis,
        username_microsite, password_microsite, handleTrimmedInputChangeA,
        showDeleteAlert, modalAlert,  closeDeleteAlertCurrentlist, modalAlertCurrentlist, handleCleanCurrentlist,
        handleDeleteAndSave, closeDeleteAlert, openDeleteAlertCurrentlist, loadingListCurrent

    } = useAddAgreement();
    // console.log("🚀 ~ IndexAddAgreement ~ id_rate:", id_rate)
    // console.log("🚀 ~ IndexAddAgreement ~ showButton:", listAgreement)
    const {
        id_company_valid,
        id_doctor_valid,
        id_pay_method_valid,
        id_financing_methods_valid,
        id_commercial_line_valid,
        id_use_cfdi_valid,
        id_seller_valid,
        contract_number_valid,
        validity_valid,
        sales_name_valid,
        sales_phone_valid,
        sales_email_valid,
        payment_name_valid,
        payment_phone_valid,
        payment_email_valid,
        payment_periodicity_valid,
        credit_limit_valid,
        percentage_credit_limit_valid,
        list_agrement_test_valid,
        quantity_sample_validity,
        branch_tree_valid
    } = validationsAgreement;

    //console.log(id_agreement);

    console.log("🚀 ~ IndexAddAgreement ~ AGREEMENTS:", agreement_mode)
    let url_helen = localStorage.getItem('url_helen');

    return (
        <Fragment>
                <>
                 <div className="customizer-links" style={{ width: "65px" }} >
                        <Nav className="flex-column nac-pills">
                            <NavLink onClick={handleGoBack} style={{cursor:'pointer'}} >
                                <div className="settings"  >
                                    <i className="fa fa-reply f-18"></i>
                                </div>
                                <span>{"Regresar"}</span>
                            </NavLink>
                           <NavLink
                                onClick={!loading ? () => saveOrUpdateAgreement(false) : null}
                                style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
                                >
                                <div className="settings">
                                    {loading ? (
                                    <i className="fa fa-spinner fa-spin f-18"></i>
                                    ) : (
                                    <i className="fa fa-floppy-o f-18"></i>
                                    )}
                                </div>

                                <span>
                                    {loading
                                    ? "Guardando..."
                                    : id_agreement > 0
                                        ? "Actualizar convenio"
                                        : "Guardar convenio"}
                                </span>
                            </NavLink>

                        </Nav>
                    </div>
                    <Container fluid={true}  className='container-global-zoom' >
                        <Row>
                        
                            <Col sm="12" md="12" lg="12" hidden={!loadingAgreement}>
                                <Col sm="12" style={{ textAlign: "center" }} >
                                    <img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '150px' }} />
                                    <br /> <p className='f-w-600 f-14 badge badge-light-primary' >Cargando información...</p>
                                </Col>
                            </Col>
                            
                            <Col sm="12" md="12" lg="12" hidden={loadingAgreement}>
                                <Row>
                                    <Col sm="12" md="4" lg="4">
                                        <div className="email-left-aside">
                                            <Card>
                                                <CardBody className='pt-3 pl-4 pr-3 pb-1' >
                                                    <div className="email-app-sidebar left-bookmark">
                                                        <Col sm="12" md="12" lg="12" className='pb-3 p-l-0 p-r-0' style={{ textAlign: "end" }} >
                                                            <ButtonGroup size='sm' className=''>
                                                                <Button disabled={id_agreement > 0 ? true : false} color='primary' outline={typeFilterAgreement === 1 ? false : true} onClick={() => handleChangeTypeFilter(1)}><i className="fa fa-building-o"></i> Convenio para empresas</Button>
                                                                {/* <Button disabled={id_agreement > 0 ? true : false} color='primary' outline={typeFilterAgreement === 2 ? false : true} onClick={() => handleChangeTypeFilter(2)}> <i className="fa fa-user-md"></i> Convenio para doctores</Button> */}
                                                            </ButtonGroup>
                                                        </Col>
                                                        <div className="media">
                                                            <div className="media-size-email">
                                                                <img className="mr-3 rounded-circle" src={require("../../assets/images/user/user.png")} alt="" />
                                                            </div>
                                                            <div className="media-body">
                                                                <h5 className="f-w-600">{"Cliente"}</h5>
                                                                {typeFilterAgreement === 1 && informationCompany?.company_turn !== undefined && <label className='txt-success f-w-600'>{informationCompany?.company_turn}</label>}
                                                            </div>
                                                        </div>
                                                        <Col sm="12" className='p-l-0 p-r-0' >
                                                            <Row>
                                                                <Col sm="6">
                                                                    {typeFilterAgreement === 1 && informationCompany?.phone !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp;  Telefono:</label><br /> {informationCompany?.phone}</label>}
                                                                    {typeFilterAgreement === 2 && informationDoctor?.specialty !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Epecialidad:</label><br /> {informationDoctor?.specialty ?? "N/A"}</label>}
                                                                </Col>
                                                                <Col sm="6">
                                                                    {typeFilterAgreement === 1 && informationCompany?.rfc !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; RFC:</label> <br />{informationCompany?.rfc}</label>}
                                                                    {typeFilterAgreement === 2 && informationDoctor?.specialty !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Dirección:</label><br /> {informationDoctor?.address ?? "N/A"}</label>}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col sm="6">
                                                                    {typeFilterAgreement === 1 && informationCompany?.payment_periodicity_value !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Periodo de credito:</label> <br /> {informationCompany?.payment_periodicity_value}</label>}
                                                                    {typeFilterAgreement === 2 && informationDoctor?.specialty !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Telefono:</label><br /> {informationDoctor?.phone ?? "N/A"}</label>}
                                                                </Col>
                                                                <Col sm="6">
                                                                    {typeFilterAgreement === 1 && informationCompany?.is_pay_for_compamy_value !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Generar cobro a : </label><br />  {informationCompany?.is_pay_for_compamy_value}</label>}
                                                                    {typeFilterAgreement === 2 && informationDoctor?.specialty !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Correo:</label><br /> {informationDoctor?.email ?? "N/A"}</label>}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col sm="6" >
                                                                    {typeFilterAgreement === 1 && informationCompany?.required_invoice_company !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Requiere factura: </label><br />  {informationCompany?.required_invoice_company}</label>} <br />
                                                                    {typeFilterAgreement === 2 && informationDoctor?.specialty !== undefined && <label className='' ><label className='txt-info f-w-600'><i className='fa fa-circle text-info'></i>&nbsp; Licencia profecional:</label><br /> {informationDoctor?.professional_license ?? "N/A"}</label>}
                                                                </Col>
                                                                {/* <Col sm="6" className='pt-3' style={{ textAlign: "end" }} >
                                                                    <Button outline color='dark' size='xs' onClick={handleGoBack}  > <i className='fa fa-reply'></i> Regresar</Button>
                                                                </Col> */}
                                                            </Row>
                                                        </Col>
                                                        <Col sm="12" md="12" lg="12" className='p-l-0 p-r-0 pt-1' >
                                                            {
                                                                typeFilterAgreement === 1 && <FormGroup>
                                                                    <Label className='f-w-600' >Filtrar por cliente</Label>
                                                                    <Select
                                                                        name="id_company"
                                                                        isClearable={true}
                                                                        placeholder="Selecciona una opción"
                                                                        options={listCompanies}
                                                                        defaultValue={id_company}
                                                                        value={id_company}
                                                                        className='input-air-primary b-r-9'
                                                                        onChange={(e) => handleChangeCompany(e)}
                                                                        isDisabled={id_agreement > 0 ? true : false}
                                                                    />
                                                                    <FormText color='danger' hidden={!id_company_valid}>Selecciona un cliente</FormText>
                                                                </FormGroup>
                                                            }
                                                            {
                                                                typeFilterAgreement === 2 && <FormGroup>
                                                                    <Label className='f-w-600' >Filtrar por doctores</Label>
                                                                    <Select
                                                                        name="id_company"
                                                                        isClearable={true}
                                                                        placeholder="Selecciona una opción"
                                                                        options={listDoctors}
                                                                        defaultValue={id_doctor}
                                                                        value={id_doctor}
                                                                        className='input-air-primary b-r-9'
                                                                        onChange={(e) => handleChangeDoctor(e)}
                                                                        onMenuScrollToBottom={() => handleScrollPaginingDoctor(pageSizeSelectDoctor)}
                                                                        isDisabled={id_agreement > 0 ? true : false}
                                                                    />
                                                                    <FormText color='danger' hidden={!id_doctor_valid}>Selecciona un cliente</FormText>
                                                                </FormGroup>
                                                            }
                                                        </Col>
                                                        <Col sm="12" md="12" lg="12" className='p-l-0 p-r-0 pb-3'>
                                                            <FormGroup>
                                                                <Label className='f-w-600' >Selecciona una razón social</Label>
                                                                <Select
                                                                    name="id_commercial_line"
                                                                    defaultValue={id_commercial_line}
                                                                    value={id_commercial_line}
                                                                    isClearable={false}
                                                                    placeholder="Selecciona una opción"
                                                                    className="input-air-primary b-r-9"
                                                                    options={listCommercialLines}
                                                                    onChange={(e) => handleSelectValuesA(e, 'id_commercial_line')}
                                                                    number={8}
                                                                    isDisabled={id_agreement > 0 ? true : false}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                                <FormText color='danger' hidden={!id_commercial_line_valid}>Selecciona una razón social</FormText>
                                                            </FormGroup>
                                                        </Col>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Col>
                                    <Col sm="8" lassName={(informationCompany.rfc === undefined && informationDoctor.specialty === undefined) ? "d-none ribbon-wrapper" : " p-l-0 p-r-0"} >
                                        <Card>
                                            <CardBody className='pl-3 pr-3 pt-3 pb-3' >
                                                {
                                                    <Col sm="12" className='p-l-0 p-r-0'>
                                                        <Row className={(informationCompany.rfc === undefined && informationDoctor.specialty === undefined) ? "d-none ribbon-wrapper" : ""}>
                                                            {
                                                                <InformationAgreement
                                                                    {
                                                                    ...{
                                                                        //FORM
                                                                        contract_number, validity, is_global, payment_periodicity, id_pay_method, id_financing_methods,
                                                                        credit_limit, percentage_credit_limit, id_use_cfdi,
                                                                        sales_name, sales_phone, sales_email, payment_name, payment_phone, payment_email, id_seller,
                                                                        observations, swift_code,

                                                                        //METHODS
                                                                        handleInputChangeA, handleSelectValuesA,

                                                                        //VALIDATIONS
                                                                        contract_number_valid, validity_valid, payment_periodicity_valid, id_pay_method_valid, id_financing_methods_valid,
                                                                        credit_limit_valid, percentage_credit_limit_valid, id_use_cfdi_valid, sales_name_valid,
                                                                        sales_phone_valid, sales_email_valid, payment_name_valid, payment_phone_valid, payment_email_valid, id_seller_valid,

                                                                        //INFORMATION COMPANY AND DOCTORS
                                                                        informationCompany,

                                                                        //LISTS
                                                                        listPayForms, listFinancingMethods, listUseCfdi, listSellers,

                                                                        //SANITARY
                                                                        sample_periodicity, is_micro,

                                                                        on_check_sanitary, is_pay_for_compamy, required_invoice_company,

                                                                        //*validate
                                                                        saveOrUpdateAgreement, id_agreement, _active_micro, border_tax, _url,
                                                                        username_microsite, password_microsite, handleTrimmedInputChangeA
                                                                    }
                                                                    }
                                                                    visibility_inputs={visibilityInputs}
                                                                />
                                                            }
                                                        </Row>
                                                    </Col>
                                                }
                                            
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Col sm="12" className={(informationCompany.company_turn === undefined) ? "d-none ribbon-wrapper" : "p-l-0 p-r-0"} >
                                    <Card>
                                        <CardBody className='pl-3 pr-2 pb-3 pt-3' >
                                            <Row>
                                                <Col sm="4">
                                                    <h5>Sucursales</h5>
                                                    <b className='txt-info' >Selecciona las sucursales en las que aplicara el convenio</b> <br /><br />
                                                    <DeniReactTreeView
                                                        items={ListBranchesTree}
                                                        ref={treeViewRef}
                                                        showCheckbox={true}
                                                        showIcon={true}
                                                        style={{ height: "245px" }}
                                                    />
                                                    <FormText color='danger' className='f-16' hidden={!branch_tree_valid}>Selecciona al menos una sucursal</FormText>
                                                </Col>
                                                <Col sm="8">
                                                    <h5>Datos del contacto</h5>
                                                    <Row className='mt-1' >
                                                        <Col sm="12" md="12" lg="12">
                                                            <span className='link text-sm text-primary badge badge-light-primary f-12'>Datos de contacto (Empresa)</span>
                                                        </Col>
                                                    </Row>
                                                    <Row className='mt-1'>
                                                        <Col sm="12" md="4" lg="4">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Nombre </Label>
                                                                <Input type="text" className='form-control form-control-sm input-air-primary b-r-9' name='sales_name' value={sales_name} autoComplete='off' onChange={handleInputChangeA} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12" md="4" lg="4">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Teléfono</Label>
                                                                <Input type="text" className='form-control form-control-sm input-air-primary b-r-9' name='sales_phone' value={sales_phone} autoComplete='off' onChange={handleInputChangeA} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12" md="4" lg="4">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Correo</Label>
                                                                <Input type="email" className='form-control form-control-sm input-air-primary b-r-9' name='sales_email' value={sales_email} autoComplete='off' onChange={handleInputChangeA} />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className='mt-1' >
                                                        <Col sm="12" md="12" lg="12">
                                                            <span className='link text-sm text-primary badge badge-light-primary f-12'>Datos de contacto de pagos</span>
                                                        </Col>
                                                    </Row>
                                                    <Row className='mt-1' >
                                                        <Col sm="12" md="4" lg="4">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Nombre</Label>
                                                                <Input type="text" className='form-control form-control-sm input-air-primary b-r-9' name='payment_name' value={payment_name} autoComplete='off' onChange={handleInputChangeA} />
                                                                <FormFeedback>Escribe mínimo 4 caracteres.</FormFeedback>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12" md="4" lg="4">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Teléfono</Label>
                                                                <Input type="text" className='form-control form-control-sm input-air-primary b-r-9' name='payment_phone' value={payment_phone} autoComplete='off' onChange={handleInputChangeA} />
                                                                <FormFeedback>{CompleteInput}</FormFeedback>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12" md="4" lg="4">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Correo</Label>
                                                                <Input type="email" className='form-control form-control-sm input-air-primary b-r-9' name='payment_email' value={payment_email} autoComplete='off' onChange={handleInputChangeA} />
                                                                <FormFeedback>{CompleteEmail}</FormFeedback>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    {/* <Row>
                                                        <Col style={{ textAlign: "end" }} sm="12" md="12" lg="12" className={id_agreement > 0 ? "d-none" : "p-4"}>
                                                            <FormGroup>
                                                                <Button outline color='primary' onClick={() => saveOrUpdateAgreement()}>{"Guardar Datos Generales"}</Button>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row> */}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Row className={(informationCompany.rfc === undefined && informationDoctor.specialty === undefined) ? "d-none ribbon-wrapper mb-5" : "mb-5"}>
                                    <Col sm="12" md="12" lg="12" className={id_agreement > 0 ? "" : "d-none"} >
                                        <Row>
                                            <Col md="6">
                                                <Card>
                                                    <CardBody className='pl-3 pr-2 pb-3 pt-3'>
                                                        <Row>
                                                            <Col sm="10">
                                                                <h5>Configuración</h5>
                                                            </Col>
                                                            {

                                                                agreement_mode !== 2 && agreement_mode !== "2" && agreement_mode !== 3 && agreement_mode !== "3" && (
                                                                    <Col sm="2" className="text-right">
                                                                        <img
                                                                            src={require("../../assets/images/borrar.png")}
                                                                            alt="Excel"
                                                                            title="Limpiar estudios de convenio"
                                                                            style={{ cursor: 'pointer', width: '25px', height: '25px' }}
                                                                            onClick={openDeleteAlertCurrentlist}

                                                                        />
                                                                    </Col>

                                                                )
                                                            }

                                                        </Row>

                                                    

                                                        <Row className="d-flex align-items-center mb-2 mt-4">

                                                            <Col xs="3" sm="5" md="5" lg="5" xl="5">
                                                                <span className="text-sm text-primary badge badge-light-primary f-12">
                                                                    Modo de Convenio:
                                                                </span>
                                                                <br /><br />
                                                                <Input
                                                                    type="select"
                                                                    className="form-control form-control-sm input-air-primary b-r-9"
                                                                    name="agreement_mode"
                                                                    value={agreement_mode}
                                                                    onChange={handleInputChangeA}
                                                                >
                                                                    <option value="1"> {url_helen === cedimi ? "Precio Especial" : " Listado Actual"}  </option>
                                                                    <option value="2">Tarifario Madre</option>
                                                                    {
                                                                        url_helen === cedimi && (
                                                                            <option value="3">Tarifario de Referencia</option>

                                                                        )
                                                                    }
                                                                </Input>
                                                            </Col>




                                                            {agreement_mode !== "1" && agreement_mode !== 1 && agreement_mode !== 3 && agreement_mode !== "3" && (
                                                                <Col sm="4">
                                                                    <span className="text-sm text-primary badge badge-light-primary f-12">
                                                                        Descuento global:
                                                                    </span>
                                                                    <br /><br />
                                                                    <Input
                                                                        className="form-control form-control-sm input-air-primary b-r-9"
                                                                        type="number"
                                                                        name='agreement_discount_global'
                                                                        value={agreement_discount_global}
                                                                        onChange={handleInputChangeA}
                                                                    />
                                                                </Col>
                                                            )}

                                                            {agreement_mode !== "2" && agreement_mode !== 2 && agreement_mode !== 3 && agreement_mode !== "3" && (
                                                                <Col xs="12" sm="6" md="6" lg="5" xl="5">
                                                                    <span className="text-sm text-primary badge badge-light-primary f-12 mr-2">
                                                                        Incluir estudios de tarifario:
                                                                    </span>
                                                                    <br /><br />

                                                                    <Label className="switch ms-2">
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="isCommercialPartner"
                                                                            onChange={on_check_list_limited}
                                                                            checked={is_list_limited}

                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </Label>
                                                                </Col>
                                                            )}

                                                            {(agreement_mode === "3" || agreement_mode === 3) && (
                                                                <Col xs="12" sm="6" md="6" lg="6" xl="6">
                                                                    <span className="text-sm text-primary badge badge-light-primary f-12">
                                                                        Seleccionar tarifario de referencia
                                                                    </span>
                                                                    <br /><br />
                                                                    <Select
                                                                        name="id_rate"
                                                                        isClearable={true}
                                                                        placeholder="Selecciona una opción"
                                                                        options={listAgreement}
                                                                        onChange={(e) => handleSelectValuesA(e, 'id_rate')}
                                                                        value={id_rate}
                                                                        menuPlacement="top"
                                                                        className='input-air-primary b-r-9 border-danger border-1'
                                                                        menuPortalTarget={document.body}
                                                                    />

                                                                </Col>
                                                            )}



                                                            {/* {showButton && (
                                                            <Button
                                                                    outline
                                                                    color='primary'
                                                                    size='xs'
                                                                    onClick={() => saveOrUpdateAgreement(false)}
                                                                    >
                                                                    <Label className='labelcreatePatient'>Actualizar Convenio</Label>
                                                                    </Button>

                                                            )} */}






                                                        </Row>

                                                        <Row className="d-flex align-items-center mb-2 mt-4">
                                                            {agreement_mode !== "2" && agreement_mode !== 2 && agreement_mode !== "3" && agreement_mode !== 3 && (
                                                                <>
                                                                    <Col sm="9" className="text-end">
                                                                        <span className='text-sm text-primary badge badge-light-primary f-12'>
                                                                            Cargar archivo CSV:
                                                                        </span>
                                                                        <br /><br />
                                                                        <FormGroup>
                                                                            <Input
                                                                                accept={".csv"}
                                                                                onChange={handleOnChange}
                                                                                type="file"
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    border: "1px solid #cccccc",
                                                                                    backgroundColor: "#f8f9fa",
                                                                                    borderRadius: "5px",
                                                                                    cursor: "pointer",
                                                                                    width: "100%",
                                                                                    textAlign: "center",
                                                                                    fontSize: "12px",
                                                                                    color: "#495057",
                                                                                }}
                                                                            />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    {file && (
                                                                        <Col sm="3" className='mt-4'>
                                                                            <Button
                                                                                outline
                                                                                color='primary'
                                                                                size='xs'
                                                                                onClick={ExamIndication}
                                                                            >
                                                                                <Label className='labelcreatePatient'>Cargar Archivo</Label>
                                                                            </Button>
                                                                        </Col>
                                                                    )}
                                                                </>

                                                            )

                                                            }

                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>

                                            <Col md="6">
                                                <Card>
                                                    <CardBody className='pl-3 pr-2 pb-3 pt-3'>
                                                        <Row>
                                                            <Col sm="12">
                                                                <h5>Selección de Examen/Perfil y Descuento</h5>
                                                            </Col>
                                                        </Row>

                                                        {agreement_mode !== 2 && agreement_mode !== "2" && agreement_mode !== 3 && agreement_mode !== "3" && (
                                                            <Row className="d-flex align-items-start mt-1">
                                                                <Col sm="12">
                                                                    <span className='link text-sm text-primary badge badge-light-primary f-12'>
                                                                        Busqueda de Exámen / Perfil
                                                                    </span>
                                                                    <br /><br />
                                                                    <FormGroup>
                                                                        <SearchAsync
                                                                            name={'id_exam_profile'}
                                                                            method={handleSelectTest}
                                                                            loincState={examProfileState}
                                                                            url="Profiles/SearchProfileExam"
                                                                            maxLenght={3}
                                                                        // isDisabled={agreement_mode !== "1"}

                                                                        />
                                                                        <FormText color='danger' hidden={!list_agrement_test_valid}>
                                                                            Selecciona al menos un examen
                                                                        </FormText>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        )}


                                                        <Row className="d-flex align-items-center mt-2">
                                                            <Col sm="8">
                                                                <span className="text-sm text-primary badge badge-light-primary f-12">
                                                                    % Descuento global:
                                                                </span>
                                                                <br /><br />
                                                                <Input
                                                                    className="form-control form-control-sm input-air-primary b-r-9"
                                                                    type="number"
                                                                    disabled={agreement_mode === "2" || agreement_mode === 2 || agreement_mode === "3" || agreement_mode === 3 || list_agrement_test.length === 0}
                                                                    value={globalPercentage}
                                                                    onChange={(e) => setGlobalPercentage(e.target.value)}
                                                                />
                                                            </Col>

                                                            {agreement_mode !== 2 && agreement_mode !== "2" && agreement_mode !== 3 && agreement_mode !== "3" && (
                                                                <Col className='mt-4' sm="4">
                                                                    <Button
                                                                        outline
                                                                        color='primary'
                                                                        size='xs'
                                                                        onClick={() => handleCalculateGlobalPercentage(id_agreement, globalPercentage)}
                                                                    >
                                                                        <Label className='labelcreatePatient'>Aplicar Descuento</Label>
                                                                    </Button>
                                                                </Col>

                                                            )}


                                                        </Row>
                                                    </CardBody>

                                                </Card>
                                            </Col>
                                        </Row>
                                        {agreement_mode !== 2 && agreement_mode !== "2" && agreement_mode !== 3 && agreement_mode !== "3" && (
                                            <>
                                                <Card className='ribbon-wrapper shadow pl-3 pr-2 pb-3 pt-3'>
                                                    <Row>
                                                        <Col sm="8">
                                                            <h5>Exámenes / Perfiles</h5>
                                                        </Col>
                                                    </Row>

                                                    <CardBody className='p-2'>

                                                        <Row className="d-flex justify-content-end">
                                                            <Col sm="4" className='text-right'>
                                                                <label className="txt-secondary">
                                                                    Cuando modifiques un precio, actualiza el convenio.
                                                                </label>
                                                                <Input
                                                                    placeholder="Buscar por descripción o código..."
                                                                    className="form-control input-air-primary b-r-12"
                                                                    onChange={handleSearch}
                                                                />
                                                            </Col>
                                                        </Row>



                                                        {loadingAgreementTest ? (
                                                            <div className='bg-info text-center f-16 mt-4'>
                                                                <i className="fa fa-spin fa-spinner"></i> Cargando...
                                                            </div>
                                                        ) :
                                                            isSearching && (results === null || results.length === 0) ? (
                                                                <div style={{ textAlign: "center" }}>
                                                                    <img src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="" />
                                                                    <br />
                                                                    <p className="f-18">No se encontró ningún Examen / Perfil.</p>
                                                                </div>
                                                            ) : (
                                                                <Row>
                                                                    <Col sm="12" md="12" lg="12">

                                                                        {
                                                                            list_agrement_test.length === 0 ? (
                                                                                <div>
                                                                                    <Col sm="12" style={{ textAlign: "center" }}>
                                                                                        <img
                                                                                            src={require("../../assets/images/loginHelenLabs/HelenLabs.png")}
                                                                                            className={view_exams ? 'animate__animated animate__pulse animate__infinite' : ""}
                                                                                            style={{ width: '110px' }}
                                                                                            alt="Helen Labs"
                                                                                        />
                                                                                    </Col>
                                                                                    <br />
                                                                                    <Col sm="12" style={{ textAlign: "center" }}>
                                                                                        <p className='f-14 text-primary'>
                                                                                            {view_exams ? <b>Carga masiva en progreso.</b> : <b>Seleccione los estudios que conformarán el convenio.</b>}
                                                                                        </p>
                                                                                    </Col>
                                                                                </div>
                                                                            ) : (
                                                                                <div className='table-responsive'>
                                                                                    <TableAgreement
                                                                                        {...{
                                                                                            handleChangeRange, handleChangePercentage, handleDeleteRange, handleAddRange,
                                                                                            handleChangePrice,
                                                                                            list_agrement_test,
                                                                                            number_format, handleCant, check_sanitary, is_micro,
                                                                                            goNextPage, goPreviousPage, totalPages, actualPage, goToPage,
                                                                                            prevPage, nextPage, totalRecords, resultCount,
                                                                                            modalCancellation, method, toggleModalCancellation, handleTest, id_agreement, handleDeleteTestCreate
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }



                                                    </CardBody>

                                                    {/* <CardFooter className='text-right'>
                                                        <Button outline color='primary' onClick={() => saveOrUpdateAgreement()}>{id_agreement > 0 ? "Actualizar convenio" : "Guardar convenio"}</Button>
                                                    </CardFooter> */}
                                                </Card>
                                            </>
                                        )
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                
                </>
                

            

            
            {modalAlert && (
                <AlertDataTable
                    titleAlert="Confirmar cambio"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert={
                        <>
                            Al cambiar al modo <strong>Tarifario Madre</strong>, se eliminarán los exámenes y perfiles en el {" "}
                            <strong>
                            {url_helen === cedimi ? "Precio Especial" : "Listado Actual"}
                            </strong>.
                            Esta acción no se puede deshacer. ¿Deseas continuar?
                        </>
                    }

                    alert1={true}
                    titleAlert1={
                        <>
                        Nuevo modo de convenio: <strong>Tarifario Madre </strong>
                        </>
                    }
                    buttonAcept
                    titleNotLoading="Si, Continuar"
                    titleDanger="Cancelar"
                    actionAcept={() => handleDeleteAndSave()}
                     loadingAlert={loadingListCurrent}
                    titleLoading="Cargando..."

                />
            )}

            {modalAlertCurrentlist && (
                <AlertDataTable
                    titleAlert="Limpiar modo de convenio"
                    visibleAlert={modalAlertCurrentlist}
                    onHideAlert={closeDeleteAlertCurrentlist}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert={
                        <>
                            ¿Está seguro de que desea borrar todos los estudios del modo de convenio: {" "}
                            <strong>
                            {url_helen === cedimi ? "Precio Especial" : "Listado Actual"}
                            </strong>.
                            Esta acción no se puede deshacer. ¿Deseas continuar?
                        </>
                    }

                    alert1={true}
                    titleAlert1={
                        <>
                        Limpiar modo de convenio: {" "}
                        <strong>
                            {url_helen === cedimi ? "Precio Especial" : "Listado Actual"}
                        </strong>
                        </>
                    }
                    buttonAcept
                    titleNotLoading="Si, Continuar"
                    titleDanger="Cancelar"
                    actionAcept={handleCleanCurrentlist}
                   
        
                />
            )}




            <ModalCodeCsv
                {
                ...{

                    modalListEgress, toggleModalListEgress, listCode, handlemove, listRepit, priceTarifarion, profileT

                }
                }
            />
            {
                <ModalDeleteTest
                    {
                    ...{
                        modalCancellation, toggleModalCancellation, handleTest, modalTitle, informationExams, handleDeleteTest
                    }
                    }
                />

            }
        </Fragment>
    )
}
